import { render, staticRenderFns } from "./six.vue?vue&type=template&id=6d68b25e&scoped=true"
import script from "./six.vue?vue&type=script&lang=js"
export * from "./six.vue?vue&type=script&lang=js"
import style0 from "./six.vue?vue&type=style&index=0&id=6d68b25e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68b25e",
  null
  
)

export default component.exports